<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.plan')" :title="$t('help.plan_title')"/>

    <v-server-table
      ref="appTable"
      name="plansTable"
      url="/admin/plans"
      :columns="columns"
      :options="options"
      @loaded="loading = false"
      @loading="loading = true"
      class="white-container"
    >
      <template slot="beforeFilter">
        <b-row>
          <b-col>
            <router-link to="plans/create">
              <b-button
                class="px-4"
              >{{ $t('plan.add') }}
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </template>
      
      <template slot="id" slot-scope="props">
        <router-link :to="{path: `/plans/edit/${props.row.id}`, params: props.row}" target="_blank">
          {{ props.row.id }}
        </router-link>
      </template>

      <template slot="beforeLimit" v-if="totalRecordsCount > 10">
        {{$t('global.showing')}}&nbsp;
      </template>
      <template slot="afterLimit" v-if="totalRecordsCount > 10">
        &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
      </template>
      <template slot="public" slot-scope="props">
        <column-check :row="props.row" column="public" />
      </template>
      <template slot="active" slot-scope="props">
        <column-check :row="props.row" column="active" />
      </template>
      <template slot="actions" slot-scope="props">
        <column-action
          :deleteUrl="`/plans/${props.row.id}`"
          @deleteItems="refreshTable('appTable')"
          :route="{path: `/plans/edit/${props.row.id}`, params: props.row}"
        />
      </template>

    </v-server-table>
  </div>
</template>
<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import i18n from "@/utils/i18n";

  export default {
    middleware: 'auth',
    name: 'Plans',
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['id', 'title', 'public', 'active', 'extras.users_count', 'actions'],
        options: {
          skin: [],
          headings: {
            id: '#',
            title: i18n.t('form.title'),
            public: i18n.t('form.public'),
            active: i18n.t('form.active'),
            'extras.users_count': i18n.t('users.users'),
            actions: i18n.t('button.edit')
          },
          sortable: [],
          filterByColumn: false,
          columnsDropdown: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: (data) => {
            localStorage.setItem('perPage', data.limit);
            return axios.get("/admin/plans", {
              params: {
                order: 'active',
                sort: 'desc',
                limit: data.limit,
                filter: data.custom,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.plansTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    destroyed() {
      Event.$off('vue-tables.plansTable.loaded');
    }
  }
</script>
